import { render, staticRenderFns } from "./WorkForm.vue?vue&type=template&id=ae38a0e4&scoped=true&"
import script from "./WorkForm.vue?vue&type=script&lang=js&"
export * from "./WorkForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkForm.vue?vue&type=style&index=0&id=ae38a0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae38a0e4",
  null
  
)

export default component.exports